import { createInertiaApp } from '@inertiajs/react'
import type { ResolvedComponent } from '@inertiajs/react'
import '../src/index.css'
import { registerWebMcpContext } from '../src/lib/webmcp'

const pages = import.meta.glob<{ default: ResolvedComponent }>('../pages/**/*.tsx')

void createInertiaApp({
  resolve: async (name) => {
    const loadPage = pages[`../pages/${name}.tsx`]
    if (!loadPage) throw new Error(`Unknown Inertia page: ${name}`)
    return (await loadPage()).default
  },
  progress: {
    color: '#2563eb',
  },
})

if (typeof navigator !== 'undefined') registerWebMcpContext()
